<template>
  <Modal :modal-active="modelValue" max-width="max-w-3xl" @close="handleClose">
    <template #header>
      <h2 class="text-lg font-bold text-secondary50 text-left">Histórico de validação</h2>
    </template>

    <template v-if="doctor">
      <div class="grid grid-cols-2 gap-6">
        <BiometryEvidencePanel
          :biometry-id="doctor.id"
          testid-prefix="history"
          max-height-class="max-h-[370px]"
        />

        <div class="flex flex-col gap-5">
          <DoctorInfoCard :doctor="doctor" />

          <BiometryHistoryCard :doctor="doctor" />
        </div>
      </div>
    </template>

    <template #footer>
      <FilledButton
        data-testid="history-close-button"
        text="Fechar"
        width="100%"
        height="48px"
        @click="handleClose"
      />
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import BiometryEvidencePanel from './BiometryEvidencePanel.vue'
import BiometryHistoryCard from './BiometryHistoryCard.vue'
import DoctorInfoCard from './DoctorInfoCard.vue'
import type { FacialBiometryDoctorItem } from '@/types/facial-biometry.types'

defineProps<{
  modelValue: boolean
  doctor: FacialBiometryDoctorItem | null
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

function handleClose() {
  emit('update:modelValue', false)
}
</script>
